import moment from 'moment';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant'

const defaultValue = {
    // 默认六周数据（不包括本周， 本周没有数据）
    [FORM_MAP.RANGE_TIME]: [
        moment().week(moment().week() - 1).startOf('isoWeek').format('YYYY-MM-DD'),
        moment().week(moment().week() - 1).endOf('isoWeek').format('YYYY-MM-DD')
    ],
   [FORM_MAP.RANGE_TIME_DIFF]: false,
   [FORM_MAP.ZONE]: ['255'],
   [FORM_MAP.REGION]: {
       regions: [],
       markets: ['255'],
       region_type: 'market'
   },
   [FORM_MAP.SYSTEM]: ['255'],
   [FORM_MAP.CHANNEL]: ['255'],
   [FORM_MAP.LANGUAGE]: ['255'],
   [FORM_MAP.RANGE_TIME_TYPE]: "Week",
 }

export default defaultValue;